import Cookies from 'js-cookie';
import { fetchJson } from '../utils/http';
const getCSRFToken = () => {
  return Cookies.get('csrftoken') || '';
};
export let CollaboratorRole = function (CollaboratorRole) {
  CollaboratorRole["Viewer"] = "VIEWER";
  CollaboratorRole["Owner"] = "OWNER";
  CollaboratorRole["Editor"] = "EDITOR";
  return CollaboratorRole;
}({});
const collaboratorsUrl = uuid => `/api/v1/folders/group/${uuid}/users/`;
const detailsUrl = (uuid, includePending) => `/api/v1/folders/group/${uuid}/details/?include_pending=${includePending}`;
export const FolderService = {
  getCollaboratorList(uuid) {
    return fetchJson(collaboratorsUrl(uuid), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'X-CSRFToken': getCSRFToken()
      }
    });
  },
  getFolderDetails(uuid, includePending = true) {
    return fetchJson(detailsUrl(uuid, includePending), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        'X-CSRFToken': getCSRFToken()
      }
    });
  },
  addFolderCollaborator(folderUuid, email) {
    return fetchJson(collaboratorsUrl(folderUuid), {
      method: 'POST',
      body: JSON.stringify({
        email: email.toString(),
        role: 'VIEWER'
      }),
      headers: {
        'X-CSRFToken': getCSRFToken(),
        'Content-Type': 'application/json'
      }
    });
  },
  removeFolderCollaborator(folderUuid, userId) {
    return fetchJson(`${collaboratorsUrl(folderUuid)}${userId}/`, {
      method: 'DELETE',
      headers: {
        'X-CSRFToken': getCSRFToken(),
        'Content-Type': 'application/json'
      }
    });
  }
};